import { Box, Typography } from '@mui/material';
import { ITermGroup } from '../types';
import { TransactionCard } from './TransactionCard';

interface TermGroupProps {
  termGroup: ITermGroup;
  currentTransactionId?: string;
  showTermHeader?: boolean;
}

export const TermGroup = ({ termGroup, currentTransactionId, showTermHeader = true }: TermGroupProps) => {
  return (
    <Box sx={{ mb: 1 }}>
      {showTermHeader && (
        <Typography variant='caption' color='text.subdued' fontWeight='bold' sx={{ display: 'block', mb: 0.5, ml: 1 }}>
          Term -{termGroup.termNumber}
        </Typography>
      )}
      <Box>
        {termGroup.transactions.map((transaction) => (
          <TransactionCard
            key={transaction.id}
            transaction={transaction}
            isCurrent={transaction.id === currentTransactionId}
          />
        ))}
      </Box>
    </Box>
  );
};
